"use client";

import type { CheckoutSession } from "./types";
import {
  hideStripeCheckoutMountElement,
  mountEmbeddedCheckout,
  prepareStripeCheckoutMountElement,
} from "./stripeCheckout";

export type CheckoutCallbacks = {
  onLoaded?: () => void;
  onError?: (err: unknown) => void;
};

export async function openCheckout(
  session: CheckoutSession,
  callbacks?: CheckoutCallbacks
): Promise<void> {
  try {
    if (session.provider === "polar") {
      const { PolarEmbedCheckout } = await import("@polar-sh/checkout/embed");
      await PolarEmbedCheckout.create(session.url, {
        theme: "light",
        onLoaded: callbacks?.onLoaded,
      });
      return;
    }

    const container = prepareStripeCheckoutMountElement({
      onDismiss: () => hideStripeCheckoutMountElement(),
    });
    try {
      callbacks?.onLoaded?.();
      await mountEmbeddedCheckout({
        clientSecret: session.client_secret,
        container,
        onComplete: () => {
          hideStripeCheckoutMountElement();
        },
      });
    } catch (mountErr) {
      hideStripeCheckoutMountElement();
      throw mountErr;
    }
  } catch (err) {
    callbacks?.onError?.(err);
    throw err;
  }
}
